var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C8.09375 7 9 7.90625 9 9C9 10.125 8.09375 11 7 11C5.875 11 5 10.125 5 9C5 7.90625 5.875 7 7 7ZM13.5312 3.0625C13.8125 3.34375 14 3.75 14 4.125V12C14 13.125 13.0938 14 12 14H2C0.875 14 0 13.125 0 12V2C0 0.90625 0.875 0 2 0H9.875C10.25 0 10.6562 0.1875 10.9062 0.4375L13.5312 3.0625ZM4 1.5V4H8.5V1.5H4ZM12.5 12V4.21875C12.5 4.15625 12.4688 4.125 12.4375 4.09375L10 1.625V4.75C10 5.1875 9.65625 5.5 9.25 5.5H3.25C2.8125 5.5 2.5 5.1875 2.5 4.75V1.5H2C1.71875 1.5 1.5 1.75 1.5 2V12C1.5 12.2812 1.71875 12.5 2 12.5H12C12.25 12.5 12.5 12.2812 12.5 12Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.19f75c454bb6854923ab3991c36bb72d.svg";
export { ForwardRef as ReactComponent };